import { createContext } from 'react';
import { Profile } from '../Types';

export interface IUserContext {
  loggedInProfile: Profile | null;
  loggedInProfileState: string;
  displayedProfile: Profile | null;
  displayedProfileState: string;
  refetchProfiles: () => void;
}

export const UserContext = createContext<IUserContext | undefined>(undefined);
